<template>
  <v-tabs v-model="activeTabId">
    <v-tab>Conversion Information</v-tab>
    <v-tab :disabled="!item.data.pixel">Pixel Log</v-tab>
    <v-tab :disabled="item.data.s2sPings.length>0">Affiliate Postback Log</v-tab>
    <v-tab :disabled="this.historyData.length>0" @click="getHistoryData" >History</v-tab>

    <!-- Conversion Information Tab -->
    <v-tab-item :key="`conversion-${item.data.id}-info`">
      <v-container fluid>
        <v-row>
          <v-col cols="6">
            <!-- LID and IP Address -->
            <label class="custom-label">LID</label>
            <v-text-field readonly :value="item.data.lid"></v-text-field>

            <label class="custom-label">IP Address</label>
            <v-text-field readonly :value="item.data.ip || ''"></v-text-field>

            <label class="custom-label">Geo</label>
            <v-text-field readonly :value="item.data.geo || ''"></v-text-field>

            <v-btn v-if="item.data.sale && user[0].can('change_sale_price')" color="orange" class="mt-4" @click="dialog = true">
              Change Price
            </v-btn>

            <v-dialog v-model="dialog" max-width="500px">
              <v-card>
                <v-card-title>
                  {{ item.data.sale ? item.data.sale.id : '' }} - Change Conversion Price
                  <v-spacer></v-spacer>
                  <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text>
                  <v-form>
                    <label class="custom-label">Price Paid *</label>
                    <v-text-field
                        v-model="pricePaid"
                        type="number"
                        required
                    ></v-text-field>

                    <label class="custom-label">Price Received *</label>
                    <v-text-field
                        v-model="priceReceived"
                        type="number"
                        required
                    ></v-text-field>

                    <v-textarea
                        v-model="notes"
                        label="Notes"
                        rows="4"
                    ></v-textarea>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-progress-circular
                      v-if="isLoading"
                      indeterminate
                      color="orange"
                  ></v-progress-circular>

                  <v-btn :disabled="isLoading" color="orange" @click="submit">
                    Submit
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>


          </v-col>

          <v-col cols="6">
            <!-- Payout Owed, Price Received, Conversion Date -->
            <label class="custom-label">Payout Owed</label>
            <v-text-field readonly :value="item.data.sale ? item.data.sale.payout : ''"></v-text-field>

            <label class="custom-label">Price Received</label>
            <v-text-field readonly :value="item.data.sale ? item.data.sale.payin : ''"></v-text-field>

            <label class="custom-label">Conversion Date</label>
            <v-text-field readonly :value="item.data.sale ? item.data.sale.dateAdded : ''"></v-text-field>

            <label class="custom-label">Click Date</label>
            <v-text-field readonly :value="item.data ? item.data.date_added : ''"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <!-- Affiliate and Campaign (clickable) -->
            <label class="custom-label">Affiliate</label>
            <v-list-item @click="showCardAffiliate(item)" class="entity-link" style="cursor: pointer; color: #1e88e5;">
              <v-list-item-content>
                <v-list-item-title>
                  {{ `${item.data.affiliate_id} - ${item.data.affiliate_name}` }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>


            <label class="custom-label">Campaign</label>
            <v-list-item @click="showCardCampaign(item)" class="entity-link" style="cursor: pointer; color: #1e88e5;">
              <v-list-item-content>
                <v-list-item-title>
                  {{ `${item.data.campaign_id} - ${item.data.campaign_name}` }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="6">
            <label class="custom-label">Sub ID 1</label>
            <v-text-field readonly :value="item.data.sub_campaign"></v-text-field>

            <template v-if="item.data.s2">
              <label class="custom-label">Sub ID 2</label>
              <v-text-field readonly :value="item.data.s2"></v-text-field>
            </template>

            <template v-if="item.data.s3">
              <label class="custom-label">Sub ID 3</label>
              <v-text-field readonly :value="item.data.s3"></v-text-field>
            </template>

            <template v-if="item.data.s4">
              <label class="custom-label">Sub ID 4</label>
              <v-text-field readonly :value="item.data.s4"></v-text-field>
            </template>

            <template v-if="item.data.s5">
              <label class="custom-label">Sub ID 5</label>
              <v-text-field readonly :value="item.data.s5"></v-text-field>
            </template>

            <template v-if="item.data.s6">
              <label class="custom-label">Sub ID 6</label>
              <v-text-field readonly :value="item.data.s6"></v-text-field>
            </template>

            <template v-if="item.data.s7">
              <label class="custom-label">Sub ID 7</label>
              <v-text-field readonly :value="item.data.s7"></v-text-field>
            </template>

            <label class="custom-label">Click ID</label>
            <v-text-field readonly :value="item.data.cid"></v-text-field>

            <label class="custom-label">Referrer</label>
            <v-text-field readonly :value="item.data.referer"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <label class="custom-label">Pixel Fired</label>
            <v-text-field readonly :value="item.data.sale ? (item.data.sale.isFired ? 'Yes' : 'No') : ''"></v-text-field>

            <label class="custom-label">Transaction ID</label>
            <v-text-field readonly :value="item.data.transaction_id"></v-text-field>
          </v-col>
        </v-row>
        <label class="custom-label">Redirect url</label>
        <v-text-field readonly :value="item.data.redirect_url"></v-text-field>
      </v-container>
    </v-tab-item>

    <v-tab-item v-if="item.data.pixel" :key="`conversion-${item.data.id}-pixel-log`">
      <v-container fluid>
        <v-row>
          <v-col cols="6">
            <label class="custom-label">Pixel ID</label>
            <v-text-field readonly :value="item.data.pixel.id"></v-text-field>

            <label class="custom-label">LID</label>
            <v-text-field readonly :value="item.data.pixel.lid"></v-text-field>

            <label class="custom-label">IP</label>
            <v-text-field readonly :value="item.data.ip"></v-text-field>
          </v-col>

          <v-col cols="6">
            <label class="custom-label">URL</label>
            <v-text-field readonly :value="item.data.pixel.url"></v-text-field>

            <label class="custom-label">Status</label>
            <v-text-field readonly :value="item.data.pixel.status"></v-text-field>

            <label class="custom-label">Reject Reason</label>
            <v-text-field readonly :value="item.data.pixel.rejectReason"></v-text-field>

            <label class="custom-label">Date Added</label>
            <v-text-field readonly :value="item.data.pixel.dateAdded"></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-tab-item>

    <v-tab-item v-if="item.data.s2sPings && item.data.s2sPings.length" :key="`conversion-${item.data.id}-postback-log`">
      <v-container fluid>
        <v-data-table
            :headers="postbackLogHeaders"
            :items="paginatedPings"
            :items-per-page="itemsPerPage"
            :page.sync="currentPage"
            :server-items-length="item.data.s2sPings.length"
            class="elevation-1"
            hide-default-footer
        >
          <template v-slot:item.url="{ item }">
            <a :href="item.url" target="_blank">{{ item.url }}</a>
          </template>
        </v-data-table>

        <v-pagination
            v-model="currentPage"
            :length="pageCount"
            class="mt-4"
        ></v-pagination>
      </v-container>
    </v-tab-item>


    <v-tab-item
        v-if="item.data.sale && item.data.sale.saleHistory && item.data.sale.saleHistory.length"
        :key="`conversion-${item.data.id}-history`"
    >

      <v-data-table
          :headers="historyHeaders"
          :items="historyData"
          :loading="isLogsLoading"
          fixed-header
          loading-text="Loading... Please wait"
          color="#7F98A5"
      >

        <template v-slot:item.logs="{ item }">
          <HistoryLog :logsString="item.logs"></HistoryLog>
        </template>
      </v-data-table>
    </v-tab-item>

  </v-tabs>
</template>

<script>

import saleApi from "@/api/sale";
import HistoryLog from "@/components/common/HistoryLog.vue";
import {mapState} from "vuex";
import store from "@/store";
import affiliates from "@/api/affiliates";
import campaignsApi from "@/api/campaigns";
export default {
  components: {HistoryLog},
  props: {
    item: {
      type: Object,
      required: true
    },
    userHasPermission: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      pricePaid: this.item.data.sale ? this.item.data.sale.payout : '',
      priceReceived: this.item.data.sale ? this.item.data.sale.payin : '',
      isLoading: false,
      notes: '',
      activeTabId: 0,
      currentPage: 1,
      itemsPerPage: 20,
      postbackLogHeaders: [
        { text: 'ID', value: 'id' },
        { text: 'URL', value: 'url' },
        { text: 'Status Code', value: 'statusCode' },
        { text: 'Attempts', value: 'attempts' },
        { text: 'Last Attempt', value: 'lastAttempt' },
        { text: 'Date Added', value: 'dateAdded' }
      ],
      historyHeaders: [
        {text: 'User', align: 'start', sortable: false, value: 'user'},
        {text: 'Action', sortable: false, value: 'action'},
        {text: 'Date', sortable: false, value: 'dateAdded'},
        {text: 'Logs', sortable: false, value: 'logs'},
      ],
      historyData: [],
      isLogsLoading: true,
    };
  },
  // mounted() {
  //   console.log("Item Data:", this.item.data);
  // },
  computed: {
    ...mapState('user', ['user']),
    paginatedPings() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.item.data.s2sPings.slice(start, end);
    },
    pageCount() {
      return Math.ceil(this.item.data.s2sPings.length / this.itemsPerPage);
    }
  },
  methods: {
    async showCardAffiliate(item) {

      let filter = item.data.affiliate_id;
      const affiliate = await affiliates.getAffiliatesProfileCO({
        payload: {
          limit: 1,
          page: 1,
          orderBy: '',
          orderDirectionAsc: false,
          filters: {'affNameId': `${filter}`}
        }
      });

      const aff = affiliate.data[0]

      if (!aff) {
        console.error(`Affiliate ${item.data.affiliate_id} not found`);
        return;
      }
     await store.dispatch('cards/ADD', {
        type: 'affiliate',
        title: aff.id,
        tab: 1,
        key: `affiliate-${aff.id}`,
        data: {...aff }
      })
    },
    async showCardCampaign(item) {

      const campaigns = await campaignsApi.getCampaignsData({
        payload: {
          showInactiveCampaigns: true,
          orderBy: 'dateAdded',
          orderDirectionAsc: false,
          page: 1,
          limit: 1,
          filters: {
            id: item.data.campaign_id
          }
        }
      });
      const campaign = campaigns.data[0];
      await store.dispatch('cards/ADD', {
        type: 'campaign',
        title: `[${campaign.id}] - [${campaign.name}] : [${campaign.status}]`,
        key: `campaign-${campaign.id}`,
        data: campaign
      })
    },
    async getHistoryData() {
      this.isLogsLoading = true;

      if (this.item.data.sale && this.item.data.sale.saleHistory) {

        this.historyData = this.item.data.sale.saleHistory.map((history) => ({
          ...history,
          dateAdded: history.dateAdded,
        }));

      } else {
        console.log("Sale or saleHistory is undefined");
        this.historyData = []; // or handle accordingly
      }

      this.isLogsLoading = false;
    },

    async submit() {
      this.isLoading = true;

      try {
        const respUpdateSale = await saleApi.updateSale({
          lid: this.item.data.lid,
          payout: this.pricePaid,
          payin: this.priceReceived,
          notes: this.notes,
        });

        if (respUpdateSale.success) {
          this.item.data.sale.payout =this.pricePaid
          this.item.data.sale.payin = this.priceReceived
          this.dialog = false;

        } else {
          alert(`Error updating sale. Please try again. ${respUpdateSale.message}`);
          console.error('Error updating sale:', respUpdateSale.error);
        }
      } catch (e) {
        console.error('An error occurred:', e);
      } finally {
        this.isLoading = false;
      }
    },
    formatDate(timestamp) {
      const date = new Date(timestamp * 1000);
      return date.toLocaleString();
    },
    getSortedHistory(history) {
      return history;
    },
    openPixelLog(pixelId) {
      console.log("Opening Pixel Log for Pixel ID:", pixelId);
    }
  }
};
</script>

<style scoped lang="sass">
.entity-link
  cursor: pointer
  color: #1e88e5

.entity-link:hover
  text-decoration: underline

.custom-label
  color: #3f1313
  font-size: 14px
  font-weight: Bold
  margin-bottom: 5px
  display: block
</style>
